class VariantSelectorSecondary extends HTMLElement {
  constructor() {
    super();

    this.variantsOptions = null;
    this.variantsHead = null;
    this.selectedVariant = '';
    this.wayToVariant = [];
    this.productId = null;
  }

  connectedCallback() {
    this.variantsOptions = this.querySelectorAll('[data-variant-option]');
    this.variantsHead = this.querySelectorAll('[data-variant-head]');
    this.productId = this.dataset.productId;
    
    this.setupVariants();
  }

  setupVariants() {
    this.variantsOptions.forEach((element) => {
      element.addEventListener('input', () => {
        this.selectedVariant = element.value;
        this.eventDispatch();
        this.updateColorBorders();
      });
    });

    this.variantsHead.forEach((element) => {
      element.addEventListener('input', () => {
        if (element.disabled) {
          return;
        }
        
        const imageVariant = element.dataset.imageVariant;
        if (imageVariant) {
          const imagePaginate = document.querySelector(`main-product-secondary-slider img[src="${imageVariant}"]`);
          if (imagePaginate && imagePaginate.parentElement) {
            imagePaginate.parentElement.click();
          }
        }
        const previousVariant = this.selectedVariant;
        const selectedColor = element.dataset.variantHead;
        this.selectHeadings(element);
        this.updateSelectedColorLabel(element);
        this.updateColorBorders();
        
        if (selectedColor) {
          this.dispatchEvent(new CustomEvent('color-change', {
            detail: { color: selectedColor },
            bubbles: true
          }));
        }
        
        if (this.selectedVariant && this.selectedVariant !== previousVariant) {
          this.eventDispatch();
        }
      });

      if (element.checked) {
        this.selectHeadings(element);
        this.updateSelectedColorLabel(element);
      }
    });

    this.variantsOptions.forEach((option) => this.selectWay(option));

    this.autoSelectHeadsIfAllSoldOut();
    
    setTimeout(() => {
      this.updateColorBorders();
    }, 0);
  }

  updateColorBorders() {
    const colorLabels = this.querySelectorAll('.option-value--color');
    colorLabels.forEach((label) => {
      label.classList.remove('is-checked');
    });

    const checkedInputs = this.querySelectorAll('.option-value--color input[type="radio"]:checked');
    checkedInputs.forEach((input) => {
      const label = input.closest('label.option-value--color');
      if (label) {
        label.classList.add('is-checked');
      }
    });
  }

  updateSelectedColorLabel(element) {
    const fieldset = element.closest('.product-option');
    if (!fieldset) return;
    
    const selectedValueSpan = fieldset.querySelector('.option-selected-value');
    if (selectedValueSpan) {
      const colorName = element.dataset.variantHead;
      selectedValueSpan.textContent = colorName || '';
    }
  }

  selectHeadings(element) {
    const nameHead = element.dataset.variantHead;
    const position = Number(element.dataset.headPosition);

    this.wayToVariant[position] = nameHead;

    this.setupVariantOptions();

    const availableOptions = Array.from(this.variantsOptions).filter(
      (option) => !option.disabled && !option.parentElement.classList.contains('hidden')
    );

    const previousVariant = this.selectedVariant;

    if (availableOptions.length > 0 && !availableOptions.some((option) => option.checked)) {
      availableOptions[0].checked = true;
      this.selectedVariant = availableOptions[0].value;
      if (this.selectedVariant !== previousVariant) {
        this.eventDispatch();
      }
    } else {
      const optionSelected = this.querySelector('[data-variant-option]:checked');
      const newSelectedVariant = optionSelected ? optionSelected.value : '';
      
      if (newSelectedVariant !== this.selectedVariant) {
        this.selectedVariant = newSelectedVariant;
        if (this.selectedVariant) {
          this.eventDispatch();
        }
      }
    }
  }

  selectWay(option) {
    if (option.checked) {
      const optionWay = option.dataset.variantOption;
      const optionWayArray = optionWay ? optionWay.split(',') : [];

      const firstHead = this.querySelector(`[data-variant-head="${optionWayArray[0]}"]`);
      const secondHead = this.querySelector(`[data-variant-head="${optionWayArray[1]}"]`);

      if (firstHead) firstHead.checked = true;
      if (secondHead) secondHead.checked = true;

      this.variantsHead.forEach((element) => {
        if (element.checked) {
          this.selectHeadings(element);
        }
      });
      
      this.updateColorBorders();
    }
  }

  setupVariantOptions() {
    this.variantsOptions.forEach((option) => {
      const optionWay = option.dataset.variantOption;
      const optionWayArray = optionWay ? optionWay.split(',') : [];

      const optionParent = option.parentElement;

      if (optionWayArray[0] === this.wayToVariant[0] && optionWayArray[1] === this.wayToVariant[1]) {
        optionParent.classList.remove('hidden');
      } else {
        optionParent.classList.add('hidden');
      }
    });
  }

  autoSelectHeadsIfAllSoldOut() {
    const hasSelectedHead = Array.from(this.variantsHead).some((head) => head.checked);

    if (!hasSelectedHead) {
      const allOptionsDisabled = Array.from(this.variantsOptions).every((option) => option.disabled);

      if (allOptionsDisabled && this.variantsOptions.length > 0) {
        const headsByPosition = new Map();

        this.variantsHead.forEach((head) => {
          const position = Number(head.dataset.headPosition);
          if (!headsByPosition.has(position)) {
            headsByPosition.set(position, head);
          }
        });

        headsByPosition.forEach((head) => {
          head.checked = true;
          this.selectHeadings(head);
        });
        
        this.updateColorBorders();
      }
    }
  }

  eventDispatch() {
    if (!this.selectedVariant) {
      return;
    }
    
    const checkedOption = this.querySelector('[data-variant-option]:checked');
    
    let price = '';
    let comparePrice = '';
    let sku = '';
    
    if (checkedOption) {
      price = checkedOption.dataset.price || '';
      comparePrice = checkedOption.dataset.comparePrice || '';
      sku = checkedOption.dataset.sku || '';
    }
    
    if (!price && this.selectedVariant) {
      const variantOption = this.querySelector(`[data-variant-option][value="${this.selectedVariant}"]`);
      if (variantOption) {
        price = variantOption.dataset.price || '';
        comparePrice = variantOption.dataset.comparePrice || '';
        sku = variantOption.dataset.sku || '';
      }
    }
    
    const event = new CustomEvent('variant-change', {
      detail: {
        variantId: this.selectedVariant,
        sku: sku,
        price: {
          price: price,
          comparePrice: comparePrice,
        },
      },
    });
    this.dispatchEvent(event);
  }
}

if (customElements.get('variant-selector-secondary') === undefined) {
  customElements.define('variant-selector-secondary', VariantSelectorSecondary);
}



